module.exports = __webpack_public_path__ + "img/foto condell 2_thumb.bf2f012f.jpg";